import { render, staticRenderFns } from "./CustomRouter.vue?vue&type=template&id=4502b072&scoped=true&"
import script from "./CustomRouter.vue?vue&type=script&lang=js&"
export * from "./CustomRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502b072",
  null
  
)

export default component.exports